import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { access, departments, rights } from "../../../utils/enoms";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { authanticatedUser, branches, capitalizeFirstLetter } from "../../../utils/helper";
import {
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { updateAdminUser } from "../../../redux/actions/admins";


export default function EditAdminUserModal({ options }) {

  const diapatch = useDispatch();
  const { openEditAdminUserModal, setOpenEditAdminUserModal, adminData } = options;
  const [role, setRole] = useState('');
  const [username, setUsername] = useState('');
  const [position, setPosition] = useState('');
  const [branch, setBranch] = useState('');
  const [status, setStatus] = useState('');
  const [accessModule, setAccessModule] = useState([]);

  const testCancle = async () => {
    setOpenEditAdminUserModal(false);
  };

  useEffect(() => {
    setUsername(adminData.username)
    setPosition(adminData.position)
    setBranch(adminData.branch)
    setAccessModule(adminData.accessModules)
    setRole(adminData.role)
    setStatus(adminData.status)
  }, [adminData])

  const tmpEditAdUser = () => {
    const tmpAd = {
      username,
      position,
      branch,
      role,
      id: adminData._id,
      accessModules: accessModule,
      token: authanticatedUser.token,
      updatedBy: authanticatedUser._id,
      status,
    }

    // console.log(tmpAd)
    diapatch(updateAdminUser(tmpAd))
    testCancle()
  }

  // const addToAccessModule = (newValue) => {
  //   var found = false;
  //   for(var i = 0; i < accessModule.length; i++) {
  //       if (accessModule[i].name === newValue.name) {
  //           found = true;
  //           toast.warning(accessModule[i].name.toUpperCase() + ' module already added');
  //           break;
  //       }

  //   }

  //   if(!found === true){
  //     setAccessModule([...accessModule, newValue])
  //   }

  // }


// Function to edit access (add new rights)
const handleModuleRights = (right, mod) => {

  const nextAccessModule = [...accessModule];
  const moduleRights = nextAccessModule.find(
    a => a.id === mod.id
  );


  if(moduleRights.rights.includes(right)){
    toast.error(right + ' right already included for '+ moduleRights.name)
  }else{
    moduleRights.rights.push(right)
  toast.success(right + ' right added to ' + moduleRights.name + ' Module')
  
  setAccessModule(nextAccessModule);
  }
  
}

const removeModuleRight = (right, mod) => {
  // Create a copy of the accessModule array to ensure immutability
  const nextAccessModule = accessModule.map(module => {
    // Find the module that matches the provided mod.id
    if (module.id === mod.id) {
      // Check if the right exists in the rights array
      if (!module.rights.includes(right)) {
        toast.error(right + ' right is not assigned to ' + module.name);
        return module; // If the right doesn't exist, return the module as is
      } else {
        // Remove the right from the rights array
        const updatedModule = {
          ...module, // Copy the existing module
          rights: module.rights.filter(r => r !== right), // Remove the right from the array
        };
        toast.error(right + ' right removed from ' + updatedModule.name + ' Module');
        return updatedModule; // Return the updated module
      }
    }
    return module; // Return other modules unchanged
  });

  // Update the state with the new accessModule
  setAccessModule(nextAccessModule);
};

  const changeDepartment = (e) => {
    e.preventDefault()
     setRole(e.target.value)
     if(e.target.value === 'it'){
      setAccessModule(access[0])
     }else{
      setAccessModule(access[1])
     }
    //  console.log(accessModule)
  }

  return (
    <Dialog
      open={openEditAdminUserModal}
      onClose={setOpenEditAdminUserModal}
      className="relative z-20"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 grid-cols-2 gap-4">
              <DialogTitle
                as="h3"
                className="text-lg mb-5 font-bold text-gray-900"
              >
                Edit Admin User
              </DialogTitle>

              <div className="col-span-1">
                <label
                  htmlFor="last-name"
                  className="block text-sm font-bold text-gray-900"
                >
                  Enter AD username
                </label>
                <div className="mt-4">
                  <input
                    id="last-name"
                    name="last-name"
                    type="text"
                    autoComplete="username"
                    disabled={true}
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    placeholder="Enter username. Eg: jflomo"
                    className="block w-full pl-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
                <div className="mt-4">
                  <input
                    id="position"
                    name="position"
                    type="text"
                    value={position}
                    autoComplete="position"
                    onChange={e => setPosition(e.target.value)}
                    placeholder="Enter Position. Eg: Database Administrator"
                    className="block w-full pl-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600  sm:leading-6"
                  />
                </div>
              
              <div className="mt-4">
                <select id="branch" onChange={e => setBranch(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <option selected>Select branch</option>
                  {branches?.map((branch, i) =>
                    <option value={branch} key={i}>{capitalizeFirstLetter(branch + ' ')} branch </option> 
                  )}
                </select>
              </div>

                <div className="mt-4">
                <select id="department" onChange={e => changeDepartment(e)}  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <option selected>{role}</option>
                  {departments?.map((dept, i) =>
                    <option value={dept.role} key={i}>{dept?.name}</option> 
                  )}
                </select>
                </div>

                <div className="mt-4">
                  <select id="accessModules" onChange={e => setAccessModule(e.target.value)} disabled={true} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    {!accessModule?.name ? <option>Select Right</option> : <option>{accessModule?.name}</option> }
                    {access?.map((mod, i) =>
                      <option value={mod.value} key={i}>{mod?.name}</option> 
                    )}
                  </select>
                </div>

                <div className="mt-4">
                <label
                  htmlFor="rights"
                  className="block text-sm font-bold text-gray-900"
                >
                  Rights
                </label>
                  <select id="rights" onChange={e => handleModuleRights(e.target.value, accessModule[0])} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option>Select Right</option>  
                    {rights?.map((item, i) =>
                      <option value={item} key={i}>{item}</option> 
                    )}
                  </select>
                </div>

                <div className="mt-4 ml-4 grid grid-cols-4 gap-4">
                    {accessModule ? accessModule[0]?.rights?.map((item, i) => (
                      <div value={item} key={i}> {item} <button onClick={() => removeModuleRight(item, accessModule[0])}><FontAwesomeIcon
                      icon={faClose}
                      className="mr-1"
                    /></button></div>
                    )) : ''}
                </div>

                <div className="mt-4">
                <select id="status" onChange={e => setStatus(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <option selected>Select Status</option>
                    <option value='active' disabled={authanticatedUser?.accessModules[0]?.rights?.includes('approve') ? false : true}>Active</option> 
                    <option value='inActive' disabled={authanticatedUser?.accessModules[0]?.rights?.includes('edit') ? false : true}>In Active</option> 
                </select>
                </div>

              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={tmpEditAdUser}
                
                className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
              >
                Update Admin User
              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => testCancle()}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
